/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PermissionsCodename {
    VIEW_PATIENTS_TAB = 'view_patients_tab',
    VIEW_PATIENTS_SUBTAB = 'view_patients_subtab',
    VIEW_PATIENTS_WAITING_SUBTAB = 'view_patients_waiting_subtab',
    VIEW_PATIENTS_INSURANCE_MEDICAL_ACTIONS_SUBTAB = 'view_patients_insurance_medical_actions_subtab',
    VIEW_PATIENTS_INSURANCE_TICKETS_SUBTAB = 'view_patients_insurance_tickets_subtab',
    VIEW_CALENDAR_TAB = 'view_calendar_tab',
    VIEW_CALENDAR_USERS_SUBTAB = 'view_calendar_users_subtab',
    VIEW_CALENDAR_ROOMS_SUBTAB = 'view_calendar_rooms_subtab',
    VIEW_CALENDAR_PLANNING_SUBTAB = 'view_calendar_planning_subtab',
    VIEW_CALENDAR_ROOMS_PLANNING_SUBTAB = 'view_calendar_rooms_planning_subtab',
    VIEW_OFFICE_TAB = 'view_office_tab',
    VIEW_OFFICE_SERVICES_SUBTAB = 'view_office_services_subtab',
    VIEW_OFFICE_EXERCISES_SUBTAB = 'view_office_exercises_subtab',
    VIEW_OFFICE_TICKETS_SUBTAB = 'view_office_tickets_subtab',
    VIEW_OFFICE_USERS_SUBTAB = 'view_office_users_subtab',
    VIEW_OFFICE_PAYMENTS_SUBTAB = 'view_office_payments_subtab',
    VIEW_OFFICE_SUBSCRIPTIONS_SUBTAB = 'view_office_subscriptions_subtab',
    VIEW_OFFICE_ROOMS_SUBTAB = 'view_office_rooms_subtab',
    VIEW_OFFICE_MEDICAL_ACTIONS_SUBTAB = 'view_office_medical_actions_subtab',
    VIEW_OFFICE_LOCATIONS_SUBTAB = 'view_office_locations_subtab',
    VIEW_STATISTICS_TAB = 'view_statistics_tab',
    VIEW_STATISTICS_VISITS_SUBTAB = 'view_statistics_visits_subtab',
    VIEW_STATISTICS_FINANCE_SUBTAB = 'view_statistics_finance_subtab',
    VIEW_STATISTICS_USERS_SUBTAB = 'view_statistics_users_subtab',
    VIEW_INSURANCES_TAB = 'view_insurances_tab',
    VIEW_INSURANCES_K_BATCHES_SUBTAB = 'view_insurances_k_batches_subtab',
    VIEW_INSURANCES_COMPANY_INSURANCE_WORKSPACES_SUBTAB = 'view_insurances_company_insurance_workspaces_subtab',
    VIEW_INSURANCES_COMPANY_INSURANCE_ACTION_PREVIEW_SUBTAB = 'view_insurances_company_insurance_action_preview_subtab',
    VIEW_INSURANCES_INSURANCE_WORKSPACES_SUBTAB = 'view_insurances_insurance_workspaces_subtab',
    VIEW_INSURANCES_COMPANY_INSURANCE_SETTINGS_SUBTAB = 'view_insurances_company_insurance_settings_subtab',
    VIEW_SETTINGS_TAB = 'view_settings_tab',
    VIEW_SETTINGS_GENERAL_SUBTAB = 'view_settings_general_subtab',
    VIEW_SETTINGS_RESERVATIONS_SUBTAB = 'view_settings_reservations_subtab',
    VIEW_SETTINGS_TEMPLATES_SUBTAB = 'view_settings_templates_subtab',
    VIEW_SETTINGS_BILLING_INFORMATION_SUBTAB = 'view_settings_billing_information_subtab',
    VIEW_SETTINGS_CONTACT_INFORMATION_SUBTAB = 'view_settings_contact_information_subtab',
    VIEW_SETTINGS_REVIEWS_SUBTAB = 'view_settings_reviews_subtab',
    VIEW_SETTINGS_EMAIL_CONFIGURATION_SUBTAB = 'view_settings_email_configuration_subtab',
    CREATE_ORDER = 'create_order',
    PAY_ORDER = 'pay_order',
    CREATE_SERVICE = 'create_service',
    GET_SERVICE_DETAIL = 'get_service_detail',
    UPDATE_SERVICE = 'update_service',
    REMOVE_SERVICE = 'remove_service',
    EDIT_COMPANY_DETAILS = 'edit_company_details',
    GET_COLLEAGUE = 'get_colleague',
    GET_SERVICE_GROUP_DETAIL = 'get_service_group_detail',
    CREATE_SERVICE_GROUP = 'create_service_group',
    UPDATE_SERVICE_GROUP = 'update_service_group',
    REMOVE_SERVICE_GROUP = 'remove_service_group',
    LIST_COLLEAGUES = 'list_colleagues',
    LIST_COLLEAGUE_SUGGESTIONS = 'list_colleague_suggestions',
    UPDATE_COLLEAGUE = 'update_colleague',
    UPDATE_COLLEAGUE_ROLE = 'update_colleague_role',
    INVITE_COLLEAGUES = 'invite_colleagues',
    DEACTIVATE_COLLEAGUE = 'deactivate_colleague',
    CREATE_PATIENT = 'create_patient',
    LIST_PATIENTS = 'list_patients',
    SEND_PATIENT_SMS = 'send_patient_sms',
    SEND_PATIENT_EMAIL = 'send_patient_email',
    GET_PATIENT_DETAIL = 'get_patient_detail',
    UPDATE_PATIENT = 'update_patient',
    REMOVE_PATIENT = 'remove_patient',
    MERGE_PATIENTS = 'merge_patients',
    PRINT_PATIENT = 'print_patient',
    CREATE_VISIT = 'create_visit',
    GET_VISIT_DETAIL = 'get_visit_detail',
    LIST_TICKETS = 'list_tickets',
    LIST_PATIENT_TICKETS = 'list_patient_tickets',
    UPDATE_VISIT = 'update_visit',
    PRINT_VISIT = 'print_visit',
    CREATE_TICKET = 'create_ticket',
    UPDATE_TICKET = 'update_ticket',
    GET_TICKET_DETAIL = 'get_ticket_detail',
    CREATE_PATIENT_TICKET = 'create_patient_ticket',
    UPDATE_PATIENT_TICKET = 'update_patient_ticket',
    DELETE_PATIENT_TICKET = 'delete_patient_ticket',
    LIST_VISITS = 'list_visits',
    LIST_VISIT_FORMS = 'list_visit_forms',
    LIST_VISIT_IMAGES = 'list_visit_images',
    DELETE_VISIT_FORM = 'delete_visit_form',
    DELETE_VISIT_IMAGE = 'delete_visit_image',
    REMOVE_VISIT = 'remove_visit',
    LIST_MY_COMPANY_SETTINGS = 'list_my_company_settings',
    LIST_MY_COMPANY_INSURANCE_SETTINGS = 'list_my_company_insurance_settings',
    LIST_MY_COMPANY_ORDERS = 'list_my_company_orders',
    CANCEL_SUBSCRIPTION = 'cancel_subscription',
    DELETE_COMPANY_ACCOUNT = 'delete_company_account',
    DEACTIVATE_MY_ACCOUNT = 'deactivate_my_account',
    CREATE_SERVICE_ACCOUNT = 'create_service_account',
    LIST_SERVICE_ACCOUNTS = 'list_service_accounts',
    GET_SERVICE_ACCOUNT_DETAIL = 'get_service_account_detail',
    UPDATE_SERVICE_ACCOUNT = 'update_service_account',
    DELETE_SERVICE_ACCOUNT = 'delete_service_account',
    CREATE_SERVICE_ACCOUNT_TOKEN = 'create_service_account_token',
    LIST_SERVICE_ACCOUNT_TOKENS = 'list_service_account_tokens',
    REVOKE_SERVICE_ACCOUNT_TOKEN = 'revoke_service_account_token',
    SET_SERVICE_ACCOUNT_ROLE = 'set_service_account_role',
    CHANGE_SERVICE_ACCOUNT_ROLE = 'change_service_account_role',
    EDIT_SERVICE_ACCOUNT_USER = 'edit_service_account_user',
    DEACTIVATE_SERVICE_ACCOUNT_USER = 'deactivate_service_account_user',
    LIST_MY_COMPANY_SERVICES = 'list_my_company_services',
    GET_MY_COMPANY = 'get_my_company',
    LIST_PACKAGES = 'list_packages',
    LIST_INCOME_STATS = 'list_income_stats',
    LIST_NEW_PATIENTS_STATS = 'list_new_patients_stats',
    LIST_PHYSIO_VISIT_STATS = 'list_physio_visit_stats',
    LIST_SERVICE_CATEGORY_PATIENT_STATS = 'list_service_category_patient_stats',
    LIST_SERVICE_CATEGORY_STATS = 'list_service_category_stats',
    LIST_VISIT_STATS = 'list_visit_stats',
    GET_ME = 'get_me',
    UPDATE_ME = 'update_me',
    PASSWORD_CHANGE = 'password_change',
    CREATE_COLLEAGUE_WORKING_HOURS = 'create_colleague_working_hours',
    GET_COLLEAGUE_WORKING_HOURS = 'get_colleague_working_hours',
    UPDATE_COLLEAGUE_WORKING_HOURS = 'update_colleague_working_hours',
    CREATE_MY_WORKING_HOURS = 'create_my_working_hours',
    GET_MY_WORKING_HOURS = 'get_my_working_hours',
    UPDATE_MY_WORKING_HOURS = 'update_my_working_hours',
    GET_MY_TIME_OFF = 'get_my_time_off',
    CREATE_MY_TIME_OFF = 'create_my_time_off',
    UPDATE_MY_TIME_OFF = 'update_my_time_off',
    DELETE_MY_TIME_OFF = 'delete_my_time_off',
    GET_COLLEAGUE_TIME_OFF = 'get_colleague_time_off',
    CREATE_COLLEAGUE_TIME_OFF = 'create_colleague_time_off',
    UPDATE_COLLEAGUE_TIME_OFF = 'update_colleague_time_off',
    DELETE_COLLEAGUE_TIME_OFF = 'delete_colleague_time_off',
    GET_RECEIPT = 'get_receipt',
    LIST_RECEIPTS = 'list_receipts',
    CREATE_SELF_RECEIPT = 'create_self_receipt',
    CREATE_EPRESCRIPTION = 'create_eprescription',
    CREATE_EVOUCHER = 'create_evoucher',
    CREATE_ESICK_NOTE = 'create_esick_note',
    CANCEL_SELF_RECEIPT = 'cancel_self_receipt',
    UPDATE_SELF_RECEIPT = 'update_self_receipt',
    CREATE_RECEIPT_FOR_COLLEAGUE = 'create_receipt_for_colleague',
    UPDATE_RECEIPT_FOR_COLLEAGUE = 'update_receipt_for_colleague',
    REMOVE_RECEIPT = 'remove_receipt',
    CANCEL_RECEIPT_FOR_COLLEAGUE = 'cancel_receipt_for_colleague',
    GET_RECEIPT_FOR_COLLEAGUE = 'get_receipt_for_colleague',
    GET_COMPANY_REWARD_PROGRESS = 'get_company_reward_progress',
    CREATE_SUBSCRIPTION = 'create_subscription',
    CREATE_SUBSCRIPTION_PAYMENT = 'create_subscription_payment',
    GET_SUBSCRIPTION = 'get_subscription',
    LIST_SUBSCRIPTIONS = 'list_subscriptions',
    GET_SUBSCRIPTION_PAYMENT = 'get_subscription_payment',
    LIST_SUBSCRIPTION_PAYMENTS = 'list_subscription_payments',
    UPDATE_SUBSCRIPTION = 'update_subscription',
    UPDATE_SUBSCRIPTION_PAYMENT = 'update_subscription_payment',
    REMOVE_SUBSCRIPTION = 'remove_subscription',
    GET_COLLEAGUE_VISIT_DETAIL = 'get_colleague_visit_detail',
    GET_ROOM_DETAIL = 'get_room_detail',
    LIST_ROOMS = 'list_rooms',
    UPDATE_ROOM = 'update_room',
    CREATE_ROOM = 'create_room',
    REMOVE_ROOM = 'remove_room',
    GET_TEMPLATE_DETAIL = 'get_template_detail',
    LIST_TEMPLATES = 'list_templates',
    UPDATE_TEMPLATE = 'update_template',
    CREATE_TEMPLATE = 'create_template',
    REMOVE_TEMPLATE = 'remove_template',
    LIST_AUDIT_LOG = 'list_audit_log',
    EXPORT_PATIENTS = 'export_patients',
    EXPORT_PATIENTS_AND_VISITS = 'export_patients_and_visits',
    DELETE_COLLEAGUE_VISIT = 'delete_colleague_visit',
    CREATE_PATIENT_FT_TICKET = 'create_patient_ft_ticket',
    CREATE_PATIENT_ISSUED_FT_TICKET = 'create_patient_issued_ft_ticket',
    UPDATE_PATIENT_FT_TICKET = 'update_patient_ft_ticket',
    REMOVE_PATIENT_FT_TICKET = 'remove_patient_ft_ticket',
    GET_PATIENT_FT_TICKET_DETAIL = 'get_patient_ft_ticket_detail',
    GET_PATIENT_FT_TICKET_LIST = 'get_patient_ft_ticket_list',
    UPLOAD_PATIENT_FT_TICKET_IMAGE = 'upload_patient_ft_ticket_image',
    GET_K_BATCH_LIST = 'get_k_batch_list',
    GET_K_BATCH_DETAIL = 'get_k_batch_detail',
    CREATE_K_BATCH = 'create_k_batch',
    REMOVE_K_BATCH = 'remove_k_batch',
    GET_COMPANY_INSURANCE_WORKSPACE_LIST = 'get_company_insurance_workspace_list',
    GET_COMPANY_INSURANCE_WORKSPACE_DETAIL = 'get_company_insurance_workspace_detail',
    CREATE_COMPANY_INSURANCE_WORKSPACE = 'create_company_insurance_workspace',
    UPDATE_COMPANY_INSURANCE_WORKSPACE = 'update_company_insurance_workspace',
    REMOVE_COMPANY_INSURANCE_WORKSPACE = 'remove_company_insurance_workspace',
    GET_INSURANCE_COMPANY_CONTRACT_DETAIL = 'get_insurance_company_contract_detail',
    CREATE_INSURANCE_COMPANY_CONTRACT = 'create_insurance_company_contract',
    UPDATE_INSURANCE_COMPANY_CONTRACT = 'update_insurance_company_contract',
    REMOVE_INSURANCE_COMPANY_CONTRACT = 'remove_insurance_company_contract',
    GET_DIAGNOSIS_LIST = 'get_diagnosis_list',
    GET_EXPERTISE_LIST = 'get_expertise_list',
    GET_MEDICAL_ACTION_LIST = 'get_medical_action_list',
    GET_INSURANCE_COMPANY_LIST = 'get_insurance_company_list',
    GET_INSURANCE_WORKSPACE_LIST = 'get_insurance_workspace_list',
    GET_INSURANCE_WORKSPACE_DETAIL = 'get_insurance_workspace_detail',
    CREATE_INSURANCE_WORKSPACE = 'create_insurance_workspace',
    UPDATE_INSURANCE_WORKSPACE = 'update_insurance_workspace',
    GET_K_BATCH_DOCUMENT_LIST = 'get_k_batch_document_list',
    UPDATE_FT_ACTION_VISIT = 'update_ft_action_visit',
    DELETE_VISIT_REVIEW = 'delete_visit_review',
    GET_VISIT_REVIEW_LIST = 'get_visit_review_list',
    GET_FILTERED_MEDICAL_ACTION_LIST = 'get_filtered_medical_action_list',
    EXPORT_MEDICAL_ACTION_LIST = 'export_medical_action_list',
    RESEND_RECEIPT_EMAIL = 'resend_receipt_email',
    SET_FIRST_ADMIN_ROLE = 'set_first_admin_role',
    SET_ADMIN_ROLE = 'set_admin_role',
    SET_RECEPTIONIST_ROLE = 'set_receptionist_role',
    SET_WORKER_ROLE = 'set_worker_role',
    CHANGE_FIRST_ADMIN_ROLE = 'change_first_admin_role',
    CHANGE_ADMIN_ROLE = 'change_admin_role',
    CHANGE_RECEPTIONIST_ROLE = 'change_receptionist_role',
    CHANGE_WORKER_ROLE = 'change_worker_role',
    EDIT_FIRST_ADMIN = 'edit_first_admin',
    EDIT_ADMIN = 'edit_admin',
    EDIT_RECEPTIONIST = 'edit_receptionist',
    EDIT_WORKER = 'edit_worker',
    DEACTIVATE_FIRST_ADMIN = 'deactivate_first_admin',
    DEACTIVATE_ADMIN = 'deactivate_admin',
    DEACTIVATE_RECEPTIONIST = 'deactivate_receptionist',
    DEACTIVATE_WORKER = 'deactivate_worker',
    GET_EXERCISES = 'get_exercises',
    EDIT_EXERCISES = 'edit_exercises',
    GET_EXERCISE_CATEGORIES = 'get_exercise_categories',
    EDIT_EXERCISE_CATEGORIES = 'edit_exercise_categories',
    EDIT_PATIENT_EXERCISES = 'edit_patient_exercises',
    GET_COMPANY_DIAGNOSTICS_LIST = 'get_company_diagnostics_list',
    CREATE_COMPANY_DIAGNOSTICS = 'create_company_diagnostics',
    GET_GUIDE_DATA = 'get_guide_data',
    UPDATE_GUIDE_DATA = 'update_guide_data',
    GET_GROUP_VISIT_DETAIL = 'get_group_visit_detail',
    CREATE_GROUP_VISIT = 'create_group_visit',
    UPDATE_GROUP_VISIT = 'update_group_visit',
    REMOVE_GROUP_VISIT = 'remove_group_visit',
    GET_MEDICAL_HISTORY_DETAIL = 'get_medical_history_detail',
    UPDATE_MEDICAL_HISTORY = 'update_medical_history',
    UPLOAD_VISIT_IMAGE = 'upload_visit_image',
    UPLOAD_VISIT_FORM = 'upload_visit_form',
    GET_VISITS_REPORT = 'get_visits_report',
    VIEW_VISIT_SENSITIVE_DATA = 'view_visit_sensitive_data',
    UPLOAD_BATCHES_TO_PUROBOT = 'upload_batches_to_purobot',
    CREATE_PORTAL_ZP_SUBMISSION = 'create_portal_zp_submission',
    GET_PORTAL_ZP_SUBMISSION = 'get_portal_zp_submission',
    CREATE_LOCATION = 'create_location',
    UPDATE_LOCATION = 'update_location',
    REMOVE_LOCATION = 'remove_location',
    GET_MRECORDS = 'get_mrecords',
    OPEN_MRECORD = 'open_mrecord',
    CREATE_MRECORD = 'create_mrecord',
    UPDATE_PAYMENT_GATE = 'update_payment_gate',
    GET_VISIT_TRIP_LIST = 'get_visit_trip_list',
    CREATE_VISIT_TRIP = 'create_visit_trip',
    UPDATE_VISIT_TRIP = 'update_visit_trip',
    DELETE_VISIT_TRIP = 'delete_visit_trip',
    ENABLE_MRECORDS = 'enable_mrecords',
    SET_COLLEAGUE_PASSWORD = 'set_colleague_password',
    CREATE_FT_TICKET_TEMPLATE = 'create_ft_ticket_template',
    UPDATE_FT_TICKET_TEMPLATE = 'update_ft_ticket_template',
    REMOVE_FT_TICKET_TEMPLATE = 'remove_ft_ticket_template',
    DETAIL_FT_TICKET_TEMPLATE = 'detail_ft_ticket_template',
    LIST_FT_TICKET_TEMPLATES = 'list_ft_ticket_templates',
    LIST_ACTION_PREVIEW = 'list_action_preview',
    INSURANCE_PRICING = 'insurance_pricing',
    PRINT_PATIENT_FT_TICKET = 'print_patient_ft_ticket',
    CREATE_STANDALONE_FT_ACTION_VISIT = 'create_standalone_ft_action_visit',
    GET_PATIENT_VOUCHER_LIST = 'get_patient_voucher_list',
    GET_PATIENT_VOUCHER_DETAIL = 'get_patient_voucher_detail',
    CREATE_PATIENT_VOUCHER = 'create_patient_voucher',
    REMOVE_PATIENT_VOUCHER = 'remove_patient_voucher',
    WAREHOUSE_TRANSACTIONS_EXPORT = 'warehouse_transactions_export',
    WAREHOUSE_TRANSACTIONS_LIST = 'warehouse_transactions_list',
    WAREHOUSE_TRANSACTIONS_CREATE = 'warehouse_transactions_create',
    WAREHOUSE_STOCK_ITEM_LIST = 'warehouse_stock_item_list',
    WAREHOUSE_STOCK_ITEM_CREATE = 'warehouse_stock_item_create',
    WAREHOUSE_STOCK_ITEM_UPDATE = 'warehouse_stock_item_update',
    WAREHOUSE_STOCK_ITEM_DELETE = 'warehouse_stock_item_delete',
    LIST_SMS_USAGE_STATS = 'list_sms_usage_stats',
    LIST_MRECORDS_USAGE_STATS = 'list_mrecords_usage_stats',
    UPLOAD_MY_PROFILE_IMAGE = 'upload_my_profile_image',
    UPLOAD_COLLEAGUE_PROFILE_IMAGE = 'upload_colleague_profile_image',
    DELETE_MY_PROFILE_IMAGE = 'delete_my_profile_image',
    DELETE_COLLEAGUE_PROFILE_IMAGE = 'delete_colleague_profile_image',
    GET_AVAILABLE_TIME_SLOTS_FOR_VISIT = 'get_available_time_slots_for_visit',
    LIST_ALL_FT_TICKETS = 'list_all_ft_tickets',
    VIEW_PURO = 'view_puro',
    MANAGE_PURO = 'manage_puro',
    USE_DICTATION = 'use_dictation',
    UPDATE_EPRESCRIPTION = 'update_eprescription',
    SIGN_EPRESCRIPTION = 'sign_eprescription',
    CANCEL_EPRESCRIPTION = 'cancel_eprescription',
    GET_EPRESCRIPTION_LIST = 'get_eprescription_list',
    GET_EPRESCRIPTION_DETAIL = 'get_eprescription_detail',
    GET_EPRESCRIPTION_SLIP = 'get_eprescription_slip',
    VERIFY_EPRESCRIPTION_CONFIG = 'verify_eprescription_config',
    UPDATE_EVOUCHER = 'update_evoucher',
    SIGN_EVOUCHER = 'sign_evoucher',
    CANCEL_EVOUCHER = 'cancel_evoucher',
    GET_EVOUCHER_LIST = 'get_evoucher_list',
    GET_EVOUCHER_DETAIL = 'get_evoucher_detail',
    GET_EVOUCHER_SLIP = 'get_evoucher_slip',
    VERIFY_EVOUCHER_CONFIG = 'verify_evoucher_config',
    SYNC_EVOUCHER_APPROVAL = 'sync_evoucher_approval',
    GET_EVOUCHER_SIGNAL_CODES = 'get_evoucher_signal_codes',
    GET_EVOUCHER_ATTACHMENT_LIST = 'get_evoucher_attachment_list',
    CREATE_EVOUCHER_ATTACHMENT = 'create_evoucher_attachment',
    GET_EVOUCHER_ATTACHMENT = 'get_evoucher_attachment',
    DELETE_EVOUCHER_ATTACHMENT = 'delete_evoucher_attachment',
    GET_SUKL_MAGISTRALITER_PRODUCT_LIST = 'get_sukl_magistraliter_product_list',
    GET_SUKL_MAGISTRALITER_PRODUCT_DETAIL = 'get_sukl_magistraliter_product_detail',
    CREATE_SUKL_MAGISTRALITER_PRODUCT = 'create_sukl_magistraliter_product',
    UPDATE_SUKL_MAGISTRALITER_PRODUCT = 'update_sukl_magistraliter_product',
    DELETE_SUKL_MAGISTRALITER_PRODUCT = 'delete_sukl_magistraliter_product',
    SAVE_AND_LOCK_VISIT_ONLY = 'save_and_lock_visit_only',
}
